export default function getStatusBarHeightFromLocal() {
    try {
        const statusBarHeight = +(localStorage.getItem("statusBarHeight") ?? 50);
        return statusBarHeight;
    } catch (e) {
        console.log("🚀 ~ getStatusBarHeightFromLocal ~ e:", e);
        return 50;
    }
}
